import client from '../client';
import interceptors from '../interceptors';
const addonsInterceptor = interceptors.get('addons');

client.interceptors.response.use(addonsInterceptor.s, addonsInterceptor.e);

const resource = 'addon-users';

export default {
  fetch: async () => await client.get(`${resource}`),
  storeOrUpdate: async (payload) => await client.post(`${resource}/store-or-update`, payload),
  delete: async (id) => await client.delete(`${resource}/${id}`),
};
